import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MentionsInput, Mention } from 'react-mentions';
import { API_BASE_URL } from '../../config';
import '../../assets/css/RichTextCommentEditor.css';
import {useParams} from "react-router-dom";

const CommentInput = ({ value, onChange, triggerAssignedUsers }) => {
    const [users, setUsers] = useState([]);

    const {id} = useParams();
    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_users_quill`, {})
            .then(res => {
                const formatted = res.data.map(user => ({
                    id: user.id,
                    display: user.username,
                }));
                setUsers(formatted);
            })
            .catch(err => console.error('Error fetching users:', err));
    }, []);

    const handleImageUpload = async () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            if (!file) return;

            const formData = new FormData();
            formData.append('image', file);

            try {
                const res = await axios.post(`${API_BASE_URL}/upload_image`, formData);
                const imageUrl = res.data.url;
                if (imageUrl) {
                    // Inject image tag into comment
                    const updatedValue = value + `<br/><img src="${imageUrl}" style="max-width: 100%"/>`;
                    const syntheticEvent = { target: { value: updatedValue } };
                    onChange(syntheticEvent);
                }
            } catch (err) {
                console.error('Error uploading image:', err);
            }
        };
    };

    return (
        <div>

            <div style={{minHeight: 400}}>

                <MentionsInput
                    value={value}
                    onChange={onChange}
                    className="mentions"
                    style={{
                        control: {
                            fontSize: 14,
                            fontWeight: 'normal',
                        },
                        highlighter: {
                            overflow: 'hidden',
                        },
                        input: {
                            padding: 10,
                            margin: 0
                        },
                        suggestions: {
                            backgroundColor: '#fff',
                            border: '1px solid #ccc',
                            zIndex: 9999,
                            borderRadius: 5,
                            padding: 10
                        },
                        suggestion: {
                            padding: '10px',
                            borderBottom: '1px solid #eee',
                            cursor: 'pointer',
                        },
                        suggestionFocused: {
                            backgroundColor: '#e0f7fa',
                        },
                    }}
                >
                    <Mention
                        trigger="@"
                        data={users}
                        onAdd={(display, user_id) => {
                            axios.post(`${API_BASE_URL}/assign_user_to_ticket`, {
                                ticket_id: id,
                                user_id: display,
                            })
                                .then(() => {
                                    if (typeof triggerAssignedUsers === 'function') {
                                        console.log('Calling triggerAssignedUsers');
                                        triggerAssignedUsers(); // This should trigger the API in <Ticket />
                                    }
                                })
                                .catch(err => console.error("Assignment failed", err));
                        }}
                    />
                </MentionsInput>

                <div style={{margin: '10px 0 20px'}}>
                    <button type="button" onClick={handleImageUpload}>
                        📷 Ajouter une image
                    </button>
                </div>
            </div>


        </div>
    );
};

export default CommentInput;
